<template>
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		class="size-[100px]"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clip-path="url(#clip0_1376_18907)">
			<path
				d="M8.00004 1.33398C4.31337 1.33398 1.33337 4.31398 1.33337 8.00065C1.33337 11.6873 4.31337 14.6673 8.00004 14.6673C11.6867 14.6673 14.6667 11.6873 14.6667 8.00065C14.6667 4.31398 11.6867 1.33398 8.00004 1.33398ZM11.3334 10.394L10.3934 11.334L8.00004 8.94065L5.60671 11.334L4.66671 10.394L7.06004 8.00065L4.66671 5.60732L5.60671 4.66732L8.00004 7.06065L10.3934 4.66732L11.3334 5.60732L8.94004 8.00065L11.3334 10.394Z"
				fill="#CE2020"
			/>
		</g>
		<defs>
			<clipPath id="clip0_1376_18907">
				<rect
					width="16"
					height="16"
					fill="white"
				/>
			</clipPath>
		</defs>
	</svg>
</template>

